
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Components
 |--------------------------------------------------------------------------
 |
 | Here we will load the Spark components which makes up the core client
 | application. This is also a convenient spot for you to load all of
 | your components that you write while building your applications.
 */

require('./../spark-components/bootstrap');

import Core from './core/core.vue';
import Login from '../spark-components/auth/login';

Vue.component('Core', Core);
Vue.component('spark-login', Login);
